import { supabaseClient } from './supabaseClient';

export const checkFeatureFlag = async (featureName) => {
  try {
    const { data: flag, error } = await supabaseClient
      .from('feature_flags')
      .select('enabled')
      .eq('feature_name', featureName)
      .single();

    if (error && error.code !== 'PGRST116') {
      console.error('Error checking feature flag:', featureName, error);
      return false; // fail-closed: unknown/error => disabled
    }

    return flag?.enabled ?? false; // fail-closed: unknown/error => disabled
  } catch (err) {
    console.error('Unexpected error checking feature flag:', featureName, err);
    return false; // fail-closed: unknown/error => disabled
  }
};

export const FEATURE_FLAGS = {
  ADMIN_ONBOARDING: 'admin_onboarding',
  MEMBER_ONBOARDING: 'member_onboarding',
  GROUP_SETUP: 'group_setup',
  AUTH: 'auth',
  MEMBER_AUTH: 'member_auth',
  ONBOARDING: 'onboarding',
  GROUP_CREATION: 'group_creation',
  PAYMENT_PROCESSING: 'payment_processing',
  AI_ASSISTANT: 'ai_assistant',
  REMINDERS: 'reminders',
  ROTATION_MANAGER: 'rotation_manager',
  SUPPORT: 'support',
  PAYOUT_CONFIRMATION: 'payout_confirmation',
  PAYMENT_TRACKING: 'payment_tracking',
  SUSU_ROUNDS: 'susu_rounds',
  INVITE_LINK_RETRIEVAL: 'invite_link_retrieval'
};
